import { useEffect, useState } from 'react';
import getInfluencerHandles from '@tcp/core/src/components/common/atoms/InfluencerBadgeHandle/helpers/influencerBadgeHelper';

function useInfluencerBadge(influencerTags, index, image, isAbOn) {
  const [handles, setHandles] = useState([]);
  const length = influencerTags?.length || 0;

  useEffect(() => {
    if (isAbOn) {
      setHandles(getInfluencerHandles(influencerTags, index, image));
    }
  }, [image, length, isAbOn]);

  return handles;
}

export default useInfluencerBadge;
